<template>
  <v-container grid-list-xs>
      <v-col cols="12" >
        <h1>Testi</h1>
      </v-col>
      <v-col cols="12" :key="key" v-for="(item,key) in value">
          {{item.tipo}} -{{item.titolo}}  <v-btn @click="curritem=item">modifica</v-btn>
      </v-col>
      <v-col cols="12" >
          <v-btn fab 
          @click="addTesto"><v-icon  large>mdi-plus</v-icon></v-btn>
      </v-col>
      <v-col cols="12">
          <testocomponent :testo="curritem" @salva="salvaTesto(curritem)"/>
      </v-col>
  </v-container>

</template>

<script>
import TestoComponent from "@/components/TestoComponent.vue";


export default {
  components:{
    testocomponent : TestoComponent,
  },
  name: 'Home',
  props:['value','idcliente'],
  data:()=>({
      curritem:{},
  }),
  methods:{
  addTesto(){
      this.value.push({tipo:'info',titolo:"titolo",testo:"scrivi qui"})
    },
  salvaTesto(item){
    console.log(item)
    /*
      const db = this.$firebase.firestore();
      item.data.idcliente = firebase.auth().currentUser.uid;
      if(item.id){
        db.collection("texts").doc(item.id)
          .set(item.data,{ merge: true });
      }
      else{
        db.collection("texts")
          .add(item.data)
          .then(data=> {
            item = data
          });
      }
    */

    }
  },
  mounted() {
    this.testCollection = [{tipo:'a',titolo:'tit',testo:'ttt'}]
    /*
    let me = this;
    const db = this.$firebase.firestore();
    db.collection("texts")
    .where("idcliente", "==", firebase.auth().currentUser.uid)
    .onSnapshot(function(querySnapshot) {
      me.testCollection =[];
            querySnapshot.forEach(function(doc) {
                me.testCollection.push({id:doc.id,data:doc.data()});
            });
            })
            */
  }
}
</script>
